import { Box, TextField, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const Inputs = () => {
  return (
    <Box>
      <Typography variant="h3">Input</Typography>
      <Box display={'flex'} gap={2} mt={2} alignItems={'flex-end'}>
        <TextField
          name="name"
          placeholder={'placeholder input'}
          fullWidth
          value={'disabled'}
          disabled
        />
        <TextField
          name="name"
          label={'Name'}
          placeholder={'placeholder input'}
          fullWidth
        />
        <TextField
          name="location"
          label={'test'}
          placeholder={'placeholder input'}
          fullWidth
          slotProps={{
            input: { startAdornment: <LocationOnIcon /> },
          }}
        />
        <TextField
          name="uploadfile"
          label={'Location'}
          placeholder={'placeholder input'}
          fullWidth
          slotProps={{
            input: { endAdornment: <AttachFileIcon /> },
          }}
        />
      </Box>
    </Box>
  );
};

export default Inputs;
